import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, withRouter } from 'react-router-dom'
import { routes } from '../../constantes/routes'
import { presentationsActions } from '../../actions/presentationsActions'
import { usersActions } from '../../actions/usersActions'
import { phasesActions } from '../../actions/phasesActions'
import { contactsActions } from '../../actions/contactsActions'
import { eventsActions } from '../../actions/eventsActions'
import { businessunitsActions } from '../../actions/businessunitsActions'
import { hospitalsActions } from '../../actions/hospitalsActions'
import { specialtiesActions } from '../../actions/specialtiesActions'
import {
  swalAlertError,
  swalAlertIsConfirm,
  swalLoading,
  swalSuccessGeneral,
} from '../../utils/swalAlert'
import { swalTitle } from '../../constantes/swalTitle'
import PlusBtn from '../buttons/PlusBtn'
import NewPresentationContainer from './new-presentation/NewPresentationContainer'
import PresentationListTable from './PresentationListTable'
import Search from '../common/Search'
import Header from '../header/Header'
import _ from 'lodash'
import { presentationsTypes } from '../../constantes/actionTypes'
import { mssgs } from '../../constantes/mssgs'
import { entitiesExport } from '../../constantes/exportEndpoints'
import { exportActions } from '../../actions/exportActions'
import { downloadCSV } from '../../utils/downloadCSV'

const PresentationContainer = () => {
  const history = useHistory()

  const allUsers = useSelector((state) => state.users)
  const userProfile = useSelector((state) => state.userProfile)
  const presentations = useSelector((state) => state.presentations)
  const phases = useSelector((state) => state.phases || [])
  const contacts = useSelector((state) => state.contacts || [])
  const events = useSelector((state) => state.events || [])
  const businessunits = useSelector((state) => state.businessunits || [])
  const hospitals = useSelector((state) => state.hospitals || [])
  const specialties = useSelector((state) => state.specialties || [])

  const [items, setItems] = useState(presentations)
  const [isDisabled, setIsDisabled] = useState(false)
  const [modalIsOpen, setIsOpen] = useState(false)
  const [search, setSearch] = useState(null)
  const [page, setPage] = useState(1)
  const [idUser, setIdUser] = useState(-1)
  const [firstRender, setFirstRender] = useState(true)

  const dispatch = useDispatch()
  const getAllUsers = () => dispatch(usersActions.getAllUsers())
  const getAllPresentationsByTitlePaged = (search, page, id_Usuario) =>
    dispatch(
      presentationsActions.getAllPresentationsByTitlePaged(
        search,
        page,
        id_Usuario,
      ),
    )
  const clearAllPresentations = () =>
    dispatch(presentationsActions.clearPresentationsList())

  // Nuevas acciones para datos del modal
  const getAllPhases = () => dispatch(phasesActions.getAllPhases())
  const getAllContacts = () => dispatch(contactsActions.getAllContacts())
  const getAllEvents = () => dispatch(eventsActions.getAllEvents())
  const getAllBusinessUnits = () =>
    dispatch(businessunitsActions.getAllBusinessUnits())
  const getAllHospitals = () => dispatch(hospitalsActions.getAllHospitals())
  const getAllSpecialties = () =>
    dispatch(specialtiesActions.getAllSpecialties())

  const delegates =
    allUsers.length > 0
      ? _.orderBy(
          allUsers.filter((user) => user.roles.codigo == 2),
          ['nombre'],
          ['asc'],
        )
      : []

  useEffect(() => {
    clearAllPresentations()
    getList()
    if (userProfile.roles.isPresentacionesVerTodas) getAllUsers()

    // Cargar datos para el modal de tasks
    getAllPhases()
    getAllContacts()
    getAllEvents()
    getAllBusinessUnits()
    getAllHospitals()
    getAllSpecialties()

    window.addEventListener('scroll', _.throttle(handleScroll, 500))
  }, [])

  useEffect(() => {
    setItems(presentations)
  }, [presentations])

  useEffect(() => {
    if (page > 1) getList()
  }, [page])

  useEffect(() => {
    if (!firstRender) resetList()
    else setFirstRender(false)
  }, [search, idUser])

  const getList = () => {
    userProfile.roles.isPresentacionesVerTodas
      ? getAllPresentationsByTitlePaged(search, page, idUser)
      : getAllPresentationsByTitlePaged(search, page, userProfile.id_Usuario)
  }

  const resetList = () => {
    setPage((p) => 1)
    clearAllPresentations()
    getList()
  }

  const handleRemovePresentation = async (idPresentation) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres eliminar la presentación?',
      )
      if (alert.isConfirmed) {
        setIsDisabled(true)
        //const response = await presentationsApi.deletePresentations(idPresentation)
        const response = await dispatch(
          presentationsActions.deletePresentation(idPresentation),
        )
        if (response.type === presentationsTypes.DELETE_PRESENTATIONS_SUCCESS) {
          await swalSuccessGeneral(
            swalTitle.Eliminado,
            mssgs.DELETE_RECORD_SUCCESSFULLY,
          )
        }
        setIsDisabled(false)
      }
    } catch (error) {
      swalAlertError(error.payload)
      setIsDisabled(true)
    }
  }

  const handleSendPresentationToContact = async (id_ContactoPresentacion) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres enviar la presentación?',
      )
      if (alert.isConfirmed) {
        swalLoading(swalTitle.Loading)
        setIsDisabled(true)
        const response = await dispatch(
          presentationsActions.sendPresentationToContact(
            id_ContactoPresentacion,
          ),
        )
        if (response.payload) {
          swalSuccessGeneral(swalTitle.Enviado, response.payload.mssg)
        }
        setIsDisabled(false)
      }
    } catch (error) {
      swalAlertError(error.payload)
      setIsDisabled(false)
    }
  }

  const handleScroll = () => {
    const documentHeight = document.body.scrollHeight
    const currentScroll = window.scrollY + window.innerHeight
    const modifier = 50

    if (currentScroll + modifier > documentHeight) {
      setPage((p) => p + 1)
    }
  }

  // Filter por delegado
  const handleChangeOption = (event) => {
    const originalValue = event.target.value
    const value = originalValue === '0' ? -1 : parseInt(originalValue)
    setIdUser(value)
  }

  const onChangeSearch = (value) => {
    if (value.trim() === '') setSearch(null)
    else setSearch(value.trim())
  }

  const openModal = () => {
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const toMain = () => {
    history.push(routes.MAIN)
  }

  const gotoEdit = (idPresentation) => {
    history.push(routes.PRESENTATION_EDIT + idPresentation)
  }

  const canEditDeleteSendPresentation = (presentation) => {
    return presentation.id_Usuario === userProfile.id_Usuario
  }

  const handleExportCSV = async () => {
    const response = await dispatch(
      exportActions.exportCSV(entitiesExport.PRESENTATIONS),
    )
    downloadCSV('Presentaciones', response)
  }

  return (
    <div className='products'>
      <Header text={'Presentaciones'} route={toMain} backBtn={true} />
      <div className='filter__wrap mb-80'>
        {userProfile.roles.isPresentacionesVerTodas ? (
          <div className='sort-role__wrap' style={{ width: '300px' }}>
            <h4 className='filter__title'>Filtrar por</h4>
            <select className='select-filter' onChange={handleChangeOption}>
              <option value={0} className='options-field'>
                Todos las presentaciones
              </option>
              {delegates.length > 0
                ? delegates.map((user) => (
                    <option
                      key={user.id_Usuario}
                      value={user.id_Usuario}
                      className='options-field'
                    >
                      {user.nombre}
                    </option>
                  ))
                : null}
            </select>
          </div>
        ) : null}
        <Search
          onChangeSearch={onChangeSearch}
          placeholder='Buscar por título...'
        />
        <div className='add__action__rigth__side'>
          <button
            onClick={handleExportCSV}
            className='btn-landing'
            style={{ cursor: 'pointer', marginLeft: '10px' }}
          >
            📊 Exportar CSV
          </button>
          <button className='action-button' onClick={openModal}>
            <PlusBtn />
            <span>Nueva presentación</span>
          </button>
        </div>
      </div>
      <PresentationListTable
        items={items}
        handleRemovePresentation={handleRemovePresentation}
        handleSendPresentationToContact={handleSendPresentationToContact}
        isDisabled={isDisabled}
        canEditDeleteSendPresentation={canEditDeleteSendPresentation}
        gotoEdit={gotoEdit}
        phases={phases}
        contacts={contacts}
        events={events}
        businessunits={businessunits}
        hospitals={hospitals}
        specialties={specialties}
      />

      <NewPresentationContainer
        modalIsOpen={modalIsOpen}
        closeModal={closeModal}
      />
    </div>
  )
}

export default withRouter(PresentationContainer)
